import { useQuery } from 'react-query'
import { Workspace } from 'types'
import { WorkspaceClient } from 'api/clients/WorkspaceClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'

export const useInvitedWorkspace = (inviteToken?: string | null) => {
  const query = useQuery<Workspace | null>(
    ['invitedWorkspace', inviteToken],
    async () => {
      if (!inviteToken) return null
      const res = await WorkspaceClient.getInvitedWorkspace(inviteToken)
      if (res.type !== SUCCESS_RESPONSE_TYPE) throw new Error('Failed to fetch workspace')
      return res.data.company
    },
    {
      enabled: !!inviteToken,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    },
  )

  return {
    workspace: query.data ?? null,
    loading: query.isLoading,
    error: query.error ? 'Failed to fetch workspace' : null,
  }
}
